// extracted by mini-css-extract-plugin
export default {"formItem":"formItem-D9nP6c","label":"label-twSk1G","desc":"desc-NHlLPo"};